import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

export interface Connection {
  name: string;
  address: string;
  token: string;
}

@Injectable({
  providedIn: 'root'
})
export class ConnectionService {

  public activeConnection: Connection;
  public address: string;
  public connections: Connection[] = []

  constructor() {
    let temp = localStorage.getItem("connections");
    if (temp != null) {
      this.connections = JSON.parse(temp);
    }

    temp = localStorage.getItem("activeConnection");
    if (temp != null) {
      let connection: Connection = JSON.parse(temp);
      
      this.activeConnection = connection;
      this.address = connection.address;
    }
    
  }
  
  isConnected () {
    let temp = localStorage.getItem("activeConnection");
    if (temp != null) {
      let connection: Connection = JSON.parse(temp);

      this.activeConnection = connection;
      this.address = connection.address;

      if (this.activeConnection.token != undefined) {
        return true;
      }

      return false;
    }
  }

  addConnection (connection: Connection) {
    //TODO: Prevent duplicate connections by checking Server Address.
    this.connections.push(connection);
    localStorage.setItem("connections", JSON.stringify(this.connections))
  }

  deleteConnection (connectionToDelete: Connection) {

    let rebuilt = [];
    for (let connection of this.connections) {
      if (connection.address != connectionToDelete.address) {
        rebuilt.push(connection);
      }
    }

    this.connections = rebuilt;
    localStorage.setItem("connections", JSON.stringify(rebuilt));

    // If connection to delete is also the active connection...
    if (this.activeConnection.address == connectionToDelete.address) {
      localStorage.removeItem("activeConnection");
      this.activeConnection = null;
      this.isConnected();
      window.location.reload();
    }
  }

  clear() {
    localStorage.clear();
    this.activeConnection = null;
    this.connections = [];
    this.address = "";
  }

  switchTo(connection: Connection) {
    this.activeConnection = connection;
    localStorage.setItem("activeConnection", JSON.stringify(connection));
  }
}
